<template>
  <div class="ps-panel ps-panel--versions">
    <div class="ps-panel-hd">
      <h2>Versões</h2>
      <p>Histórico de atualizações do sistema.</p>
    </div>
    <div class="ver-top-row">
      <div class="ver-current-badge">
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><polygon points="8 1 10.18 5.41 15 6.18 11.5 9.59 12.36 14.41 8 12.11 3.64 14.41 4.5 9.59 1 6.18 5.82 5.41 8 1"/></svg>
        Versão atual: <strong>v{{ CURRENT_VERSION }}</strong>
      </div>
      <button class="ver-force-btn" :class="{ 'ver-force-btn--loading': loading }" type="button" :disabled="loading" @click="handleForceUpdate">
        <svg v-if="!loading" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>
        <svg v-else class="spin" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M12 2a10 10 0 0 1 0 20" stroke-linecap="round"/></svg>
        {{ loading ? 'Atualizando…' : 'Forçar atualização' }}
      </button>
    </div>
    <div class="ver-timeline">
      <div v-for="entry in CHANGELOG" :key="entry.version" class="ver-entry">
        <div class="ver-entry-hd">
          <span class="ver-tag">v{{ entry.version }}</span>
          <span class="ver-date">{{ entry.date }}</span>
        </div>
        <div v-for="section in entry.sections" :key="section.title" class="ver-section">
          <p class="ver-section-title" :class="`ver-section-title--${section.title.toLowerCase()}`">{{ section.title }}</p>
          <ul class="ver-list">
            <li v-for="item in section.items" :key="item">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { CHANGELOG, CURRENT_VERSION } from '@/store/versionStore'
import { forceHardReload } from '@/store/swUpdateStore'

export default defineComponent({
  name: 'ProfileVersoesTab',
  setup() {
    const loading = ref(false)
    const handleForceUpdate = async () => {
      loading.value = true
      await forceHardReload()
    }
    return { CHANGELOG, CURRENT_VERSION, loading, handleForceUpdate }
  }
})
</script>

<style scoped lang="scss">
.ps-panel--versions { max-width: 600px; }

.ver-top-row {
  display: flex; align-items: center; justify-content: space-between;
  gap: 12px; flex-wrap: wrap; margin-bottom: 20px;
}

.ver-current-badge {
  display: inline-flex; align-items: center; gap: 7px;
  background: rgba(15,76,129,0.08); color: var(--system-navbar, #0f4c81);
  border: 1px solid rgba(15,76,129,0.18); border-radius: 20px;
  padding: 6px 14px; font-size: 13px; font-weight: 500;
  svg { flex-shrink: 0; }
  strong { font-weight: 700; }
}

.ver-force-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; font-size: 12px; font-weight: 600;
  border-radius: 8px; border: 1px solid var(--border-strong);
  background: var(--surface-3); color: var(--ink); cursor: pointer;
  transition: background .15s, opacity .15s;
  &:hover:not(:disabled) { background: var(--surface-2); }
  &:disabled { opacity: .5; cursor: not-allowed; }
  &--loading { opacity: .7; }
}

.spin { animation: spin 1s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }

.ver-timeline { display: flex; flex-direction: column; gap: 28px; }

.ver-entry { display: flex; flex-direction: column; gap: 12px; }

.ver-entry-hd { display: flex; align-items: baseline; gap: 10px; }

.ver-tag {
  font-size: 14px; font-weight: 800; color: var(--system-navbar, #0f4c81);
  background: rgba(15,76,129,0.08); border: 1px solid rgba(15,76,129,0.15);
  border-radius: 6px; padding: 2px 10px;
}

.ver-date { font-size: 12px; color: var(--ink-muted); }

.ver-section { display: flex; flex-direction: column; gap: 6px; }

.ver-section-title {
  font-size: 11px; font-weight: 700; text-transform: uppercase;
  letter-spacing: .06em; margin: 0;
  &--novo { color: #0d9488; }
  &--melhorias { color: #7c3aed; }
  &--correções { color: #dc2626; }
  &--técnico { color: var(--ink-muted); }
}

.ver-list {
  margin: 0; padding-left: 18px; display: flex; flex-direction: column; gap: 4px;
  li { font-size: 13px; color: var(--ink-muted); line-height: 1.5; }
}
</style>
